// ─────────────────────────────────────────────
// Configuración de monedas — solo visual
// El cobro real se sigue procesando en USD.
// Precios fijos por moneda (redondeo comercial), no conversión en vivo.
// ─────────────────────────────────────────────

export const CURRENCIES = {
  USD: { code: 'USD', symbol: '$',   label: 'USD', name: 'Dólar',           flag: '🇺🇸', locale: 'en-US' },
  BOB: { code: 'BOB', symbol: 'Bs ', label: 'BOB', name: 'Boliviano',       flag: '🇧🇴', locale: 'es-BO' },
  MXN: { code: 'MXN', symbol: '$',   label: 'MXN', name: 'Peso mexicano',   flag: '🇲🇽', locale: 'es-MX' },
  EUR: { code: 'EUR', symbol: '€',   label: 'EUR', name: 'Euro',            flag: '🇪🇺', locale: 'es-ES' },
};

export const DEFAULT_CURRENCY = 'USD';

// Código de país (ISO-2, viene de Cloudflare CF-IPCountry) → moneda
export const COUNTRY_CURRENCY = {
  BO: 'BOB',
  MX: 'MXN',
  // Zona euro
  ES: 'EUR', DE: 'EUR', FR: 'EUR', IT: 'EUR', PT: 'EUR', NL: 'EUR',
  BE: 'EUR', AT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR', SK: 'EUR',
  SI: 'EUR', LT: 'EUR', LV: 'EUR', EE: 'EUR', LU: 'EUR', MT: 'EUR',
  CY: 'EUR', HR: 'EUR',
};

// Tabla de precios fijos. Clave = precio en USD.
// Cada fila trae el equivalente redondeado por moneda.
// Tipo de cambio aprox: 1 USD = 10.2 BOB, 18 MXN, 0.92 EUR.
export const PRICE_TABLE = {
  // Servicios web (precios "Desde")
  299:    { USD: 299,    BOB: 3050,  MXN: 5499,  EUR: 275 },
  599:    { USD: 599,    BOB: 6110,  MXN: 10999, EUR: 549 },
  899:    { USD: 899,    BOB: 9170,  MXN: 16499, EUR: 829 },
  // Planes de hosting (/mes)
  2.99:   { USD: 2.99,   BOB: 30,    MXN: 55,    EUR: 2.99 },
  6.99:   { USD: 6.99,   BOB: 71,    MXN: 129,   EUR: 6.99 },
  14.99:  { USD: 14.99,  BOB: 153,   MXN: 279,   EUR: 13.99 },
  29.99:  { USD: 29.99,  BOB: 306,   MXN: 549,   EUR: 27.99 },
  // Productos NexusAI (/mes)
  1:      { USD: 1,      BOB: 10,    MXN: 19,    EUR: 0.99 },
  19.99:  { USD: 19.99,  BOB: 204,   MXN: 369,   EUR: 18.99 },
  29:     { USD: 29,     BOB: 296,   MXN: 529,   EUR: 27 },
  31.99:  { USD: 31.99,  BOB: 326,   MXN: 579,   EUR: 29.99 },
  39.99:  { USD: 39.99,  BOB: 408,   MXN: 719,   EUR: 37.99 },
  49.99:  { USD: 49.99,  BOB: 510,   MXN: 899,   EUR: 45.99 },
  59.99:  { USD: 59.99,  BOB: 612,   MXN: 1099,  EUR: 54.99 },
  69:     { USD: 69,     BOB: 705,   MXN: 1259,  EUR: 63 },
  79.99:  { USD: 79.99,  BOB: 819,   MXN: 1469,  EUR: 73.99 },
  99:     { USD: 99,     BOB: 1010,  MXN: 1799,  EUR: 91 },
  99.99:  { USD: 99.99,  BOB: 1020,  MXN: 1819,  EUR: 91.99 },
  129.99: { USD: 129.99, BOB: 1325,  MXN: 2349,  EUR: 119.99 },
  // Condominios — escalado por bloque de unidades (/mes)
  50:     { USD: 50,     BOB: 510,   MXN: 899,   EUR: 45 },
  100:    { USD: 100,    BOB: 1020,  MXN: 1799,  EUR: 91 },
  200:    { USD: 200,    BOB: 2040,  MXN: 3599,  EUR: 184 },
};

// Devuelve la moneda sugerida para un código de país.
export function detectCurrencyFromCountry(countryCode) {
  if (!countryCode) return DEFAULT_CURRENCY;
  return COUNTRY_CURRENCY[countryCode.toUpperCase()] || DEFAULT_CURRENCY;
}

// Formatea un precio (dado en USD) a la moneda indicada.
// Usa la tabla de precios fijos; si el valor no está en la tabla,
// muestra el valor USD tal cual con el formato de la moneda.
export function formatPrice(usdValue, currencyCode) {
  const cur = CURRENCIES[currencyCode] || CURRENCIES[DEFAULT_CURRENCY];
  const row = PRICE_TABLE[usdValue];
  const amount = row ? row[cur.code] : usdValue;
  const hasDecimals = !Number.isInteger(amount);
  const formatted = new Intl.NumberFormat(cur.locale, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(amount);
  return `${cur.symbol}${formatted}`;
}
